import { render, staticRenderFns } from "./LPButton.vue?vue&type=template&id=b9426992&scoped=true"
import script from "./LPButton.vue?vue&type=script&lang=ts"
export * from "./LPButton.vue?vue&type=script&lang=ts"
import style0 from "./LPButton.vue?vue&type=style&index=0&id=b9426992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9426992",
  null
  
)

export default component.exports